import { FC } from "react";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import GenButton from "../GenButton/GenButton";

interface GenNotFoundProps {
  message?: string;
  title?: string;
  onClick?: () => void;
}

const GenNotFound: FC<GenNotFoundProps> = (props) => {
  const { message, title, onClick } = props;
  return (
    <Container maxWidth='lg'>
      <Box flexGrow={1} display='flex' justifyItems='center' mt={5} width='100vh' flexDirection='column'>
        <Typography variant="h2">{title || 'Opp..'}</Typography>
        {message && !onClick && <Typography>{message}</Typography>}
        {message && onClick && <GenButton onClick={onClick} sx={{ width: 5 }}>{message}</GenButton>}
      </Box>
    </Container>
  )
}

export default GenNotFound;